import reducre from './reducer'
import alarmDeviceTypeSagas from '../components/deviceType/store/sagas'
import failureTypeSagas from '../components/failureType/store/sagas'
const sagas=[alarmDeviceTypeSagas,failureTypeSagas]
export { reducre,sagas }